import { lazy,Route } from '@tanstack/router'

import protectRoute from '../hoc/protectRoute'
import { rootRoute } from './root'

const ImSports = lazy(() => import('../pages/sports/im-sports'))

export const imSportsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/sports/im',
  component: protectRoute(ImSports, true),
})
